// Remembered portfolio selection (this device). ?pid= wins, then the saved choice, then the first portfolio.
const KEY = "msx_selected_portfolio";
export const PF_EVENT = "msx-portfolio-changed";

export const rememberPortfolio = (id) => {
  if (!id) return;
  try { localStorage.setItem(KEY, id); } catch { /* ignore */ }
  window.dispatchEvent(new CustomEvent(PF_EVENT, { detail: id }));
};

export const pickPortfolio = (list) => {
  const all = list || [];
  let saved = null;
  try { saved = localStorage.getItem(KEY); } catch { /* ignore */ }
  const want = new URLSearchParams(window.location.search).get("pid");
  const p = all.find((x) => x.id === want) || all.find((x) => x.id === saved) || all[0] || null;
  if (p && p.id !== saved) rememberPortfolio(p.id);
  return p;
};
